import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import { SxProps, Theme } from '@mui/material';
import { LengthUnit, LENGTH_UNITS } from '@fastsheep/densicalc-core';

type LengthUnitSelectorProps = {
	value: LengthUnit;
	onChange: (value: LengthUnit) => void;
	sx?: SxProps<Theme>;
	id?: string;
	label?: string;
	size?: 'small' | 'medium' | undefined;
	disabled?: boolean;
};
export default function LengthUnitSelector(props: LengthUnitSelectorProps) {
	const onChange = (
		event: SelectChangeEvent<LengthUnit>,
		child: React.ReactNode
	) => {
		props.onChange(event.target.value as LengthUnit);
	};
	// @ts-ignore
	const width = props.sx && props.sx.width ? props.sx.width : '10vw';
	return (
		<FormControl sx={{ ...props.sx, width: width }}>
			<InputLabel id="length_unit_label">
				{props.label ? props.label : ''}
			</InputLabel>
			<Select
				labelId="length_unit_label"
				size={props.size ? props.size : 'small'}
				label={props.label ? props.label : ''}
				name={props.id ? props.id : 'length_unit'}
				id={props.id ? props.id : 'length_unit'}
				data-cy={props.id ? props.id : 'length_unit'}
				value={props.value}
				onChange={onChange}
				disabled={props.disabled ? props.disabled : false}
			>
				{LENGTH_UNITS.map((unit, idx) => (
					<MenuItem
						key={idx}
						value={unit.code}
						id={unit.code}
						data-cy={unit.code}
					>
						{unit.displayName}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
}
